// SharedRequestBanner — small inline notice rendered at the top of TryItForm
// when the form has been pre-filled from a shared `#try=…` URL hash. Lets the
// user dismiss (which also strips the hash so subsequent edits don't compete
// with the snapshot).

import { Link2, X } from 'lucide-react';

interface Props {
    onDismiss: () => void;
}

export default function SharedRequestBanner({ onDismiss }: Props) {
    return (
        <div
            className="flex items-center justify-between gap-3 px-3 py-2 rounded-md text-xs"
            style={{ backgroundColor: 'var(--accent-bg)', border: '1px solid var(--accent-bg)', color: 'var(--accent-2)' }}
            role="status"
            aria-live="polite"
        >
            <span className="inline-flex items-center gap-2">
                <Link2 className="h-3.5 w-3.5" />
                Request dari shared link — sudah ter-load di form di bawah.
            </span>
            <button
                type="button"
                onClick={onDismiss}
                className="inline-flex items-center gap-1 px-2 py-1 rounded text-xxs hover:bg-emerald-900/30 transition-colors"
                style={{ color: 'var(--accent-2)' }}
                aria-label="Tutup notifikasi shared link"
            >
                <X className="h-3 w-3" />
                Tutup
            </button>
        </div>
    );
}
